import { useMutation, useQuery } from '@tanstack/react-query';
import apiClient from './api-client';
const SCOPE = 'refinance';
const DETAIL = 'detail';
const keysFactory = {
    all: (financingProgram) => [{ scope: SCOPE, financingProgram }],
    allDetails: (financingProgram) => [{ scope: SCOPE, entity: DETAIL, financingProgram }],
    detail: (id, financingProgram) => [{ scope: SCOPE, entity: DETAIL, id, financingProgram }],
};
const getRefinancingParams = async ({ queryKey: [{ id, financingProgram }], }) => {
    const response = await apiClient.get(`/${financingProgram}/creditApplication/${encodeURIComponent(id)}/refinancing`);
    return response.data;
};
export function useGetRefinancingParams(creditApplicationId, financingProgram) {
    const { isFetching, data } = useQuery({
        queryKey: keysFactory.detail(creditApplicationId, financingProgram),
        queryFn: getRefinancingParams,
        enabled: !!creditApplicationId,
    });
    return [data ?? null, isFetching];
}
const submitRefinancing = (financingProgram) => async (dto) => {
    const response = await apiClient.post(`${financingProgram}/creditApplication/${dto.id}/refinancing`, dto);
    return response.data;
};
export function useSubmitRefinancing(financingProgram) {
    const { mutateAsync, isPending, reset } = useMutation({
        mutationFn: submitRefinancing(financingProgram),
    });
    return [mutateAsync, isPending, reset];
}
